import httpApi from '../api/httpApi';
import useSWR from 'swr';

const COLLECTION_URL = '/api/v1/products/collection-id-by-handle/';

const useGetCollectionIdByHandleSWR = (collectionHandle: string) => {
    const url = COLLECTION_URL + collectionHandle;
    const fetch = (query): Promise<any> => {
        return httpApi
            .get<{ collectionId: number }>(query)
            .then((res) => {
                return res.getData().collectionId;
            })
            .catch((error) => {
                throw error;
            });
    };

    const { data, error, isLoading } = useSWR(url, fetch, {
        errorRetryCount: 3,
    });

    return {
        collectionId: data ? data : null,
        isCollectionIdLoading: isLoading,
        isCollectionIdError: error,
    };
};

export default useGetCollectionIdByHandleSWR;
